import React from 'react';
import { useRouterContext, TitleProps } from '@pankod/refine-core';
import { Box, Center } from '@pankod/refine-mantine';

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
  const { Link } = useRouterContext();

  return (
    <Link to="/">
      <Box p="xs" pl={0} style={{ textAlign: 'center' }}>
        {collapsed ? (
          <img src="/ballerine-collapsed.svg" alt="Verkend" />
        ) : (
          <img src="/verkend.png" alt="Verkend" width="140px" />
        )}
      </Box>
    </Link>
  );
};
